import { useEffect } from 'react'

/**
 * Used to lazy load a 3rd party script until its needed
 *
 * @param id
 * @param url
 * @param async
 * @param crossOrigin
 */
const useExternalScript = (id: string, url, async = true, crossOrigin = 'anonymous') => {
  useEffect(() => {
    if (document.getElementById(id)) {
      // other component already added this element to the DOM
      // don't do anything
      return
    }

    const script = document.createElement('script')
    script.id = id
    script.src = url
    script.async = async
    script.crossOrigin = crossOrigin
    document.body.appendChild(script)
  }, [id, async, crossOrigin, url])
}

export const useLoadAdsenseScript = () => {
  // load adsense
  return useExternalScript(
    'adsense-script',
    'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3952596231252607'
  )
}

export default useExternalScript
